import { FilterOperator, FilterableField, Filter as FilterInput } from '__generated__/globalTypes';
import { CarveDetailsCard } from 'features/deals/DealStages/EventActionCards/CarveDetailsCardBody/__generated__/fragments';
import { Criteria } from './CreateCarveForm';

// A filter as it comes back on a query response (real __typename, matching
// whatever the server actually returned). Distinct from FilterInput
// (globalTypes.Filter) below, which is the schema's INPUT type for this same
// shape -- GraphQL input types never carry __typename, and the server
// rejects one if sent. Conflating the two used to be harmless (neither had
// __typename before this migration); now that a real discriminated union
// exists, it isn't -- criteriaToFilters constructs mutation input and must
// return FilterInput, not this.
type Filter = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<Extract<CarveDetailsCard, { __typename: 'CarveDetailsCard' }>>['carves']
    >[number]
  >['carve']
>[number];
export const convertFiltersToCriteria = (filters: Filter[]): Criteria[] => {
  // Group the filters by their field_name
  const groupedFilters: { [key in FilterableField]?: Filter[] } = {};

  for (const filter of filters) {
    const key = filter.field_name;
    if (!groupedFilters[key]) {
      groupedFilters[key] = [];
    }
    groupedFilters[key]?.push(filter);
  }

  // Convert grouped filters to criteria
  const criteriaList: Criteria[] = [];
  for (const [field, fieldFilters] of Object.entries(groupedFilters)) {
    const criteria: Criteria = {
      field: field as unknown as FilterableField,
    };

    if (fieldFilters) {
      for (const filter of fieldFilters) {
        switch (filter.operator) {
          case FilterOperator.GREATER_THAN_OR_EQUALS:
          case FilterOperator.GREATER_THAN:
            criteria.min = filter.operand ? Number(filter.operand) : null;
            break;
          case FilterOperator.LESS_THAN_OR_EQUALS:
          case FilterOperator.LESS_THAN:
            criteria.max = filter.operand ? Number(filter.operand) : null;
            break;
          case FilterOperator.IS:
            if (!criteria.values) criteria.values = [];
            criteria.values = filter.operandList || undefined;
            break;
        }
      }
    }

    criteriaList.push(criteria);
  }

  return criteriaList;
};

export const criteriaToFilters = (criteriaList: Criteria[]): FilterInput[] => {
  const filters: FilterInput[] = [];

  for (const criteria of criteriaList) {
    const { field, min, max, values } = criteria;

    if (min !== undefined && min !== null) {
      filters.push({
        field_name: field,
        operator: FilterOperator.GREATER_THAN_OR_EQUALS,
        operand: min.toString(),
        operandList: null,
      });
    }

    if (max !== undefined && max !== null) {
      filters.push({
        field_name: field,
        operator: FilterOperator.LESS_THAN_OR_EQUALS,
        operand: max.toString(),
        operandList: null,
      });
    }

    if (values) {
      filters.push({
        field_name: field,
        operator: FilterOperator.IS,
        operand: null,
        operandList: values,
      });
    }
  }

  return filters;
};
